import React from 'react';
import { X } from 'lucide-react';

interface KeyboardShortcutsProps {
  onClose: () => void;
}

const SHORTCUTS = [
  { key: 'M', desc: 'Switch to Map view' },
  { key: '3', desc: 'Switch to 3D view' },
  { key: 'S', desc: 'Switch to Split view' },
  { key: 'Esc', desc: 'Reset 3D camera / close panels' },
  { key: 'Shift + ?', desc: 'Show this help' },
];

export const KeyboardShortcuts: React.FC<KeyboardShortcutsProps> = React.memo(({ onClose }) => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Keyboard shortcuts"
    >
      <div
        className="w-full max-w-sm rounded-xl border border-slate-600/50 bg-slate-900 p-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-sm font-semibold uppercase tracking-wider text-slate-300">
            Keyboard Shortcuts
          </h2>
          <button
            onClick={onClose}
            className="rounded-md p-1 text-slate-400 hover:bg-slate-700/50 hover:text-slate-200 transition-colors"
            aria-label="Close shortcuts"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="flex flex-col gap-2">
          {SHORTCUTS.map((s) => (
            <div
              key={s.key}
              className="flex items-center justify-between rounded-md bg-slate-800/50 px-3 py-2"
            >
              <kbd className="rounded bg-slate-700 px-1.5 py-0.5 text-xs font-mono text-sky-300">
                {s.key}
              </kbd>
              <span className="text-xs text-slate-300">{s.desc}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default KeyboardShortcuts;
